<template>
  <div
    style="margin-bottom: 20px;padding-right:15px;"
  >
    <v-card
      class="mt-4 mx-auto"
      max-width="100%"
      :elevation="1"
      style="margin-top: 20px;"
    >
      <v-layout
        wrap
        style="padding: 20px;"
      >
        <v-flex xs12 text-center style="padding-right: 10px;padding-top: 20px;">
          <stats-source
            :workspaceID="enterpriseID"
            :locale="locale" 
            :onChangeSourcesList="(v) => { sources = v}"
          />
        </v-flex>
        <v-flex v-if="showOld" xs6 text-center style="padding-right: 10px;padding-top: 20px;">
<v-card :elevation="0" style="border: 0.5px solid #CCCCCC4D;padding:5px;">
          <center v-if="!stats"><span style="font-family:Helvetica, Arial, sans-serif;font-size:14px;">{{ $t('dashboard.stats.accessMenu')}} {{enterpriseName}}</span></center>
          <v-progress-linear
            v-if="loading"
            indeterminate
            :color="enterpriseColor"
          />
          <v-btn v-else-if="!stats" style="margin-top:10px" :color="enterpriseColor" @click="handleGetData" dark>{{ $t('common.show') }}</v-btn>
          <stats-charts v-if="stats" :typeData="type" :stats="stats" style="margin-top: 20px;"/>
          <!-- <v-card-text class="pt-0">
            <span class="caption grey--text font-weight-light">last access 26 minutes ago</span>
          </v-card-text> -->
          <table v-if="stats" style="margin-top: -40px">
            <tr>
              <td width="50%" class="text-right" style="padding: 10px;">
                {{ $t('dashboard.stats.month') }}
              </td>
              <td>
                <v-switch v-model="isByDay" @change="handleChangeType" style="padding-top: 10px;" color="dtouch" />
              </td>
              <td width="50%" class="text-left" style="padding: 10px;">
                {{ $t('dashboard.stats.day') }}
              </td>
            </tr>
          </table>
          <!-- <v-btn-toggle v-model="type" style="margin-bottom:20px;">
            <v-btn text value="M"
              @click="handleChangeType('M')"
            >
              {{ $t('dashboard.stats.month') }}
            </v-btn>
            <v-btn text value="D"
              @click="handleChangeType('D')"
            >
              {{ $t('dashboard.stats.day') }}
            </v-btn>
          </v-btn-toggle> -->
</v-card>
        </v-flex>
        <v-flex xs12 text-center style="padding: 0 0 0 0;">
          <stats-charts-v2 :workspaceID="enterpriseID" :sources="sources"  style="margin-top: 20px;"/>
          <!-- <v-card-text class="pt-0">
            <span class="caption grey--text font-weight-light">last access 26 minutes ago</span>
          </v-card-text> -->
          <!-- <v-btn-toggle v-model="type" style="margin-bottom:20px;">
            <v-btn text value="M"
              @click="handleChangeType('M')"
            >
              {{ $t('dashboard.stats.month') }}
            </v-btn>
            <v-btn text value="D"
              @click="handleChangeType('D')"
            >
              {{ $t('dashboard.stats.day') }}
            </v-btn>
          </v-btn-toggle> -->
        </v-flex>
        <!--v-flex v-if="showOld" xs6 style="padding-left:0px;padding-right:10px;padding-top:20px;">
          <v-card elevation="1" style="padding: 20px 0;">
            <center>
              <span style="font-family:Helvetica, Arial, sans-serif;font-size:14px;">
                {{ $t('dashboard.stats.accessMenu')}} {{enterpriseName}}
              </span>
            </center>
            <stats-table v-if="enterpriseID && !isDevelopment" :enterpriseID="enterpriseID" />
          </v-card>
        </v-flex-->
        <!--v-flex xs6 style="padding:20px 0 0 0;">
        </v-flex-->
        <v-flex xs6 style="padding:20px 10px 0 0;">
          <v-card elevation="1" style="padding: 20px 0;">
          <center>
            <span style="font-family:Helvetica, Arial, sans-serif;font-size:14px;">
                <b>[WEBAPP]</b> {{ $t('dashboard.stats.accessMenu')}} {{enterpriseName}} V2
            </span>
          </center>
          <stats-table-v2
            v-if="enterpriseID" 
            :workspaceID="enterpriseID" 
            :sources="sources"
          />
        </v-card>
        </v-flex>
        <v-flex xs6 style="padding:20px 0 0 10px;">
          <v-card elevation="1" style="padding: 20px 0;">
          <center>
            <span style="font-family:Helvetica, Arial, sans-serif;font-size:14px;">
                <b>[TOTEM]</b> {{ $t('dashboard.stats.accessMenu')}} {{enterpriseName}} V2
            </span>
          </center>
          <stats-table-totem-v2
            v-if="enterpriseID" 
            :workspaceID="enterpriseID" 
            :sources="sources"
          />
        </v-card>
        </v-flex>
        <!--v-flex xs6 style="padding-left:20px;padding-top:20px;">
          <v-card elevation="1" style="padding: 20px 0;">
          <center><span style="font-family:Helvetica, Arial, sans-serif;font-size:14px;">{{ $t('dashboard.stats.accessMenu')}} TOTEM</span></center>
          <stats-table-totem v-if="enterpriseID && !isDevelopment" :enterpriseID="enterpriseID" />
        </v-card>
        </v-flex-->
      </v-layout>
    </v-card>
  </div>
</template>
<script>
  import api from '@/services/api'
  import StatsCharts from './StatsCharts'
  import StatsChartsV2 from './StatsChartsV2'
  //import StatsTable from './StatsTable'
  import StatsTableV2 from './StatsTableV2'
  import StatsTableTotemV2 from './StatsTableTotemV2'
  //import StatsTableTotem from './StatsTableTotem'
  import StatsSource from './statsSource/Index'
  export default {
    components: {
      StatsCharts,
      StatsChartsV2,
      //StatsTable,
      StatsTableV2,
      StatsTableTotemV2,
      //StatsTableTotem,
      StatsSource,
    },
    props: {
      locale: {
        type: String,
        required: true
      },
      enterpriseID: {
        type: String,
        required: true
      }
    },
    data: () => ({
      loading: false,
      showStatsChartsV2: false,
      isByDay: false,
      type: 'M',
      entID: null,
      stats: null,
      menus: null,
      sources: [],
    }),
    computed: { 
      enterpriseName() {
        return this.$store.state.app.enterpriseName
      },
      enterpriseColor() {
        return this.$store.state.app.enterpriseColor
      },
      isDevelopment () {
        return process.env.VUE_APP_ENV === 'development' ? true : false
      },
      showOld () {
        return this.$route.query.old ? true : false
      },
    },
    watch: {
      enterpriseID: {
        handler: function (newValue) {
          this.stats = null
          this.entID = newValue
          //this.handleGetStats(newValue)
        },
        deep: true
      },
    },
    mounted () {
      this.entID = this.enterpriseID
      //this.handleGetStats(this.enterpriseID)
    },
    methods: {
      handleGetData() {
        this.handleGetStats(this.enterpriseID)
      },
      handleChangeType(type) {
        this.type = type ? 'D' : 'M'
        this.handleGetStats(this.entID)
      },
      handleGetStats (id) {
        if (!this.showOld) return
        this.loading = true
        let filter = []
        if (this.type === 'M') {
          for (let i = 0; i < 12; i++) {
            const date = new Date()
            date.setMonth(date.getMonth() - i)
            if (filter.indexOf(`${date.getMonth() + 1} / ${date.getFullYear()}`) < 0) filter.push(`${date.getMonth() + 1} / ${date.getFullYear()}`)
          }
        } else {
          for (let i = 0; i < 7; i++) {
            const date = new Date()
            date.setDate(date.getDate() - i)
            filter.push(`${date.getDate()} / ${date.getMonth() + 1} / ${date.getFullYear()}`)
          }
        }        
        api.getAll(`stats/${id}/${this.type}/main`, 1, 100000, '').then(response => {          
          filter = filter.map(item => {
            const aux = this.type === 'M' ? 
                                response.filter(x => `${x.Month} / ${x.Year}` === item) :
                                response.filter(x => `${x.Day} / ${x.Month} / ${x.Year}` === item)
            this.loading = false
            return ({
              key: item,
              value: aux.length > 0 ? aux[0].Count : 0
            })
          })
          this.stats = filter
        })
      },
    }
  }
</script>
<style>
  .v-sheet--offset {
    top: -24px;
    position: relative;
  }
</style>
